import en from './en';
import es from './es';
// removed FR locale import for now, as it is not used in the current implementation

export default { en, es };
